export default __webpack_public_path__ + "static/media/testimonial_kubalos.36159d5a.jpg";